// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"227":"fb870634","400":"0efc7d4c","760":"d3574796","935":"b4dcd440"}[chunkId] + ".css";
};